import { lazy, Suspense, useEffect } from 'react';
import { emitGameEvent, GameEvents } from '../../pages/Home/eventEmiter';
import { useAppSelector } from '../../store';
import AviatorGameContainer from '../../pages/Home/AviatorGameContainer';
import GlobalGame from '../../PhaserGameClass/GlobalGame';

const AviatorRocket = lazy(() => import('../AviatorRocket'));

function AviatorWrapper() {
  const { activeGame } = useAppSelector(
    ({ aviator }) => aviator,
  );
  const { userData } = useAppSelector(
    ({ profile }) => profile,
  );
  useEffect(() => {
    GlobalGame.scene.stop('PreloadScene');
    GlobalGame.scene.stop('UpgradeScene');
    GlobalGame.updateParent('aviator');
    GlobalGame.scene.start('AviatorScene');
  }, []);
  useEffect(() => {
    if (userData?.character_progress) {
      emitGameEvent({ event: GameEvents.SET_CHARACTER_PROGRESS, characterProgress: userData.character_progress });
    }
  }, [userData?.character_progress, activeGame]);
  return (
    <div>
      <AviatorGameContainer />
      {activeGame === 'aviator' && (
      <Suspense>
        <AviatorRocket />
      </Suspense>
      )}
    </div>
  );
}

export default AviatorWrapper;
